import { take, call, put, getContext } from "redux-saga/effects"
import historyChannel from "../channels/history"
import { Creators } from "../../actions/app/history"
import queryString from "query-string"

export default function* historySaga() {
  const router = yield getContext("router")
  const channel = yield call(historyChannel, router.subscribe)
  while (true) {
    const location = yield take(channel)
    location.query = yield call(queryString.parse, location.search)
    yield put(Creators.navigate(location))
  }
}
